import ModerationListController from './moderation.list.controller';
import Template from './moderation.list.tpl.html';

export default {
	controller: ModerationListController,
	template: Template
};
